import request from '@/utils/request'


// 查询用户身体设置列表
export function listBody(query) {
  return request({
    url: '/joe/user-body/list',
    method: 'get',
    params: query
  })
}

// 查询用户身体设置分页
export function pageBody(query) {
  return request({
    url: '/joe/user-body/page',
    method: 'get',
    params: query
  })
}

// 查询用户身体设置详细
export function getBody(data) {
  return request({
    url: '/joe/user-body/detail',
    method: 'get',
    params: data
  })
}

// 新增用户身体设置
export function addBody(data) {
  return request({
    url: '/joe/user-body/add',
    method: 'post',
    data: data
  })
}

// 修改用户身体设置
export function updateBody(data) {
  return request({
    url: '/joe/user-body/edit',
    method: 'post',
    data: data
  })
}

// 删除用户身体设置
export function delBody(data) {
  return request({
    url: '/joe/user-body/delete',
    method: 'post',
    data: data
  })
}
